'use strict';exports.__esModule = true;exports.resetNeighborhoodCompany = exports.findByNeighborhood = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var findByNeighborhood = (0, _reduxAct.createAction)('/FIND_BY_NEIGHBORHOOD');
var findByNeighborhoodSuccess = (0, _reduxAct.createAction)('/FIND_BY_NEIGHBORHOOD_SUCCESS');
var findByNeighborhoodFail = (0, _reduxAct.createAction)('/FIND_BY_NEIGHBORHOOD_FAIL');

var resetNeighborhoodCompany = (0, _reduxAct.createAction)('/RESET_NEIGHBORHOOD_COMPANY');

var initialState = {
  loaded: false,
  loading: false,
  data: null };


var fetchFindByNeighborhood = function fetchFindByNeighborhood(_ref) {var city = _ref.city,neighborhood = _ref.neighborhood,access_token = _ref.access_token;
  var payload = {
    params: {
      city: city,
      neighborhood: neighborhood } };



  return _axios2.default.get('agencies/find_by_neighborhood', payload).
  then(findByNeighborhoodSuccess, findByNeighborhoodFail);
};

var handleFindByNeighborhood = function handleFindByNeighborhood(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { error: null, loaded: false, loading: true, data: null }), promise(fetchFindByNeighborhood, data)));};

var handleFindByNeighborhoodSuccess = function handleFindByNeighborhoodSuccess(state, _ref2) {var data = _ref2.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleFindByNeighborhoodFail = function handleFindByNeighborhoodFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleResetNeighborhoodCompany = function handleResetNeighborhoodCompany(state) {return Object.assign({},
  state,
  initialState);};


var companyFindByNeighborhood = (0, _reduxAct.createReducer)(function (on) {
  on(findByNeighborhood, handleFindByNeighborhood);
  on(findByNeighborhoodSuccess, handleFindByNeighborhoodSuccess);
  on(findByNeighborhoodFail, handleFindByNeighborhoodFail);
  on(resetNeighborhoodCompany, handleResetNeighborhoodCompany);
}, initialState);exports.


findByNeighborhood = findByNeighborhood;exports.
resetNeighborhoodCompany = resetNeighborhoodCompany;exports.default =


companyFindByNeighborhood;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/findByNeighborhood.js
// module id = 592
// module chunks = 0